<template>
  <div class="co-form-wrap">
    <div class="state-bar" v-if="!editStatus && currentState">
      <div :class="['state-pill', `state-${currentState.type}`]">
        <span class="dot"></span>
        {{ currentState.text }} · {{ currentState.desc }}
      </div>
    </div>

    <el-form
      ref="ruleForm"
      :model="form"
      :rules="rules"
      :disabled="disable"
      label-width="140px"
      label-position="right"
      class="co-form"
    >
      <el-form-item label="电子营业执照" prop="avatar">
        <el-upload
          class="avatar-uploader"
          :action="action"
          :show-file-list="false"
          :headers="headers"
          :on-success="onAvatarSuccess"
          :before-upload="beforeAvatarUpload"
          :on-error="onUploadError"
          :disabled="!!imageUrl || !editStatus"
        >
          <img v-if="imageUrl" :src="imageUrl" class="avatar-preview" />
          <div v-else class="avatar-placeholder">
            <i class="el-icon-plus"></i>
            <p>上传营业执照</p>
            <p class="hint">支持 png / jpg / pdf，≤20MB</p>
          </div>
        </el-upload>
        <div v-if="imageUrl" class="avatar-filename">
          {{ fileName }}
          <i class="el-icon-circle-close" v-if="editStatus && form.state != 4" @click="removeAvatar"></i>
        </div>
      </el-form-item>

      <div class="form-grid">
        <el-form-item label="企业名称" prop="coName">
          <el-input v-model="form.coName" placeholder="请输入营业执照上的企业全称"></el-input>
        </el-form-item>
        <el-form-item label="企业所在地" prop="coAddress">
          <el-input v-model="form.coAddress" placeholder="如：江西省上饶市余干县"></el-input>
        </el-form-item>
        <el-form-item label="统一社会信用代码" prop="coCode">
          <el-input v-model="form.coCode" placeholder="请输入 18 位统一社会信用代码"></el-input>
        </el-form-item>
        <el-form-item label="企业法人" prop="coLep">
          <el-input v-model="form.coLep" placeholder="法人姓名"></el-input>
        </el-form-item>
        <el-form-item label="法人身份证号" prop="coLepCode">
          <el-input v-model="form.coLepCode" placeholder="法人身份证号"></el-input>
        </el-form-item>
        <el-form-item label="联系人" prop="contName">
          <el-input v-model="form.contName" placeholder="联系人姓名"></el-input>
        </el-form-item>
        <el-form-item label="联系方式" prop="contPhone">
          <el-input v-model="form.contPhone" placeholder="联系人手机号"></el-input>
        </el-form-item>
        <el-form-item label="联系人职务" prop="contPost">
          <el-input v-model="form.contPost" placeholder="如：项目经理"></el-input>
        </el-form-item>
      </div>

      <el-form-item label="授权书" prop="word">
        <div class="auth-book">
          <el-upload
            :action="action"
            :headers="headers"
            :limit="1"
            :on-success="onWordSuccess"
            :on-remove="removeFile"
            :file-list="fileList"
            :disabled="!editStatus || form.state == 4"
          >
            <div v-if="!fileList.length" class="auth-trigger">
              <i class="el-icon-upload"></i>
              <span>上传授权书</span>
            </div>
          </el-upload>
          <a v-if="!fileList.length" class="auth-template" href="https://www.ygctszfw.com/up/uploadPath/数据服务系统信息传输授权书.doc">
            <i class="el-icon-download"></i>
            下载《数据服务系统信息传输授权书》模板
          </a>
        </div>
      </el-form-item>

      <div class="form-actions">
        <button
          v-if="canReedit"
          type="button"
          class="g-btn g-btn-default g-btn-lg"
          @click="enterEdit"
        >重新编辑</button>
        <button
          v-if="editStatus || !form.state"
          type="button"
          class="g-btn g-btn-primary g-btn-lg"
          @click="submit('ruleForm')"
        >{{ form.state ? '保存修改' : '提交认证' }}</button>
        <button
          v-if="editStatus && form.state"
          type="button"
          class="g-btn g-btn-default g-btn-lg"
          @click="cancelEdit"
        >取消</button>
        <button
          v-if="form.state == 4 || form.state == 4"
          type="button"
          class="g-btn g-btn-default g-btn-lg"
          @click="emitUnbind"
        >解绑手机</button>
      </div>
    </el-form>
  </div>
</template>

<script>
import baseUrl from '@/lib/utils/baseUrl'
import { addInfo, editInfo, delImg } from '@/lib/api/attestation'
import { CO_STATES } from './ucHelpers'

export default {
  name: 'CoEditForm',
  props: {
    initialForm: { type: Object, default: () => ({}) }
  },
  data () {
    return {
      action: baseUrl + '/buiness/coword/uploadFile',
      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') },
      form: { ...this.initialForm },
      editStatus: false,
      disable: true,
      imageUrl: '',
      fileName: '',
      fileList: [],
      hasFmt: false,
      rules: {
        coName: [{ required: true, message: '请填写企业名称', trigger: 'blur' }],
        coAddress: [{ required: true, message: '请填写企业所在地', trigger: 'blur' }],
        coCode: [{ required: true, message: '请填写社会统一信用代码', trigger: 'blur' }],
        coLep: [{ required: true, message: '请填写企业法人', trigger: 'blur' }],
        coLepCode: [
          { required: true, message: '请填写法人身份证号', trigger: 'blur' },
          { pattern: /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/, message: '身份证格式不正确' }
        ],
        contName: [{ required: true, message: '请填写联系人', trigger: 'blur' }],
        contPhone: [
          { required: true, message: '请填写联系方式', trigger: 'blur' },
          { pattern: /^1[3-9]\d{9}$/, message: '手机号格式不正确' }
        ],
        contPost: [{ required: true, message: '请填写联系人职务', trigger: 'blur' }]
      }
    }
  },
  computed: {
    currentState () {
      return this.form.state != null ? CO_STATES[this.form.state] : null
    },
    canReedit () {
      return !this.editStatus && [4, 2, 3].includes(Number(this.form.state))
    }
  },
  watch: {
    initialForm: {
      deep: true,
      handler (v) {
        this.form = { ...v }
        this.imageUrl = v.url || ''
        this.fileList = v.wordUrl ? [{ name: v.wordName, url: v.wordUrl }] : []
        this.disable = true
        this.editStatus = !v.id
      }
    }
  },
  methods: {
    onAvatarSuccess (res) {
      if (res.code === 200) {
        this.imageUrl = res.url
        this.hasFmt = true
        this.fileName = res.url.split('//')[1].split('/').pop()
      }
    },
    beforeAvatarUpload (file) {
      const ok = ['image/jpeg', 'image/png', 'application/pdf'].includes(file.type)
      const size = file.size / 1024 / 1024 < 20
      if (!ok) this.$message.error('图片格式不正确')
      if (!size) this.$message.error('图片不能超过 20MB')
      this.hasFmt = true
      return ok && size
    },
    onUploadError (err) { this.$message.error(typeof err === 'string' ? err : '上传失败') },
    removeAvatar () {
      if (this.form.state != 4 && this.editStatus) {
        delImg({ url: this.imageUrl }).then(() => {
          this.hasFmt = false
          this.imageUrl = ''
          this.fileName = ''
          this.$message.success('删除成功')
        })
      }
    },
    onWordSuccess (res, file) {
      if (res.code === 200) {
        this.fileList = [{ name: file.name, url: res.url }]
      }
    },
    removeFile () {
      if (this.form.state == 4) {
        return this.$message.warning('账号信息已认证，无法删除')
      }
      this.fileList = []
    },
    enterEdit () { this.editStatus = true; this.disable = false },
    cancelEdit () { this.editStatus = false; this.disable = true },
    submit (formName) {
      this.$refs[formName].validate((valid) => {
        if (!valid) return
        const payload = { ...this.form, url: this.imageUrl, wordUrl: this.fileList[0] && this.fileList[0].url }
        const fn = this.form.state ? editInfo : addInfo
        fn(payload).then((res) => {
          if (res.code === 200) {
            this.$message.success('提交成功')
            this.$store.commit('isCheck', res.data)
            this.$emit('saved', res.data)
            this.editStatus = false
            this.disable = true
          } else {
            this.$message.error(res.msg)
          }
        })
      })
    },
    emitUnbind () { this.$emit('unbind') }
  }
}
</script>

<style lang="less" scoped>
@import '~@/assets/styles/variables.less';

.co-form-wrap {
  background: #fff;
  border-radius: @radius-lg;
  padding: 32px 40px;
  box-shadow: @shadow-sm;
}

.state-bar { margin-bottom: 24px; }

.state-pill {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 8px 16px;
  border-radius: @radius-full;
  font-size: 13px;
  font-weight: 500;

  .dot {
    width: 8px; height: 8px;
    border-radius: 50%;
    background: currentColor;
  }

  &.state-primary { background: @primary-soft; color: @primary; }
  &.state-success { background: @success-soft; color: @success; }
  &.state-danger  { background: @danger-soft; color: @danger; }
  &.state-info    { background: @info-soft; color: @info; }
}

.co-form {
  ::v-deep .el-form-item__label {
    color: @text-secondary;
    font-size: 13px;
  }
}

.form-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 0 32px;
}

.avatar-uploader {
  ::v-deep .el-upload {
    border: 1px dashed @border-base;
    border-radius: @radius-md;
    cursor: pointer;
    background: @bg-soft;
    transition: all @duration-fast @ease-out;
    &:hover { border-color: @primary; background: @primary-soft; }
  }
}

.avatar-preview {
  display: block;
  width: 200px;
  height: 140px;
  object-fit: cover;
  border-radius: @radius-md;
}

.avatar-placeholder {
  width: 200px;
  height: 140px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: @text-muted;

  i { font-size: 28px; margin-bottom: 8px; color: @primary; }
  p { margin: 0; font-size: 13px; }
  .hint { color: @text-disabled; font-size: 12px; margin-top: 4px; }
}

.avatar-filename {
  margin-top: 10px;
  font-size: 13px;
  color: @primary;
  display: flex;
  align-items: center;
  gap: 6px;

  i { cursor: pointer; }
}

.auth-book {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.auth-trigger {
  width: 220px;
  height: 90px;
  border: 1px dashed @border-base;
  border-radius: @radius-md;
  background: @bg-soft;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: @text-muted;
  cursor: pointer;
  transition: all @duration-fast @ease-out;

  &:hover { border-color: @primary; color: @primary; }
  i { font-size: 24px; margin-bottom: 6px; }
}

.auth-template {
  font-size: 13px;
  color: @primary;
  text-decoration: none;
}

.form-actions {
  display: flex;
  gap: 12px;
  margin-top: 24px;
  padding-top: 24px;
  border-top: 1px solid @border-light;
}
</style>
